import WorkflowSetupPage from '../workflows/pages/WorkflowSetupPage';

/**
 * Wraps WorkflowSetupPage with a module filter.
 * Shows only workflow templates belonging to this module and restricts
 * supervisor/assignee dropdowns to positions in the module's Access scope.
 */
export default function ModuleWorkflowTab({ moduleKey, scope, scopeLoading }) {
  if (scopeLoading) {
    return <p style={{ color: 'var(--text-muted)', padding: 24 }}>Loading workflow setup...</p>;
  }

  const scopedPositions = scope?.positions || [];

  if (scopedPositions.length === 0) {
    return (
      <div style={{
        padding: 20, borderRadius: 8,
        background: 'rgba(218, 165, 32, 0.08)',
        border: '1px solid rgba(218, 165, 32, 0.25)',
        color: 'var(--text-primary)',
      }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Configure Access first</div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          No positions have been granted access to this module yet. Open the <strong>Access</strong> tab
          to pick a team, position, or user — those selections become the candidates for workflow supervisors.
        </div>
      </div>
    );
  }

  return (
    <WorkflowSetupPage
      moduleFilter={moduleKey}
      scopedPositionIds={scopedPositions.map(p => p.id)}
    />
  );
}
